import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectPromotionTypeChangeReason } from '../../../../../../selectors/publishTerms';
import { selectIsMobileLayout } from '../../../../../../selectors/layout';

import { PromotionTypeChangeWarning } from './components';

export const PromotionWarningContainer = () => {
  const promotionTypeChangeReason = useSelector(selectPromotionTypeChangeReason);
  const isMobileLayout = useSelector(selectIsMobileLayout);

  if (promotionTypeChangeReason) {
    return <PromotionTypeChangeWarning mobile={isMobileLayout} text={promotionTypeChangeReason} />;
  }

  return null;
};
